package presentation.screens.business.onboard.create_business_screen.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import common.asset.ImageAsset
import component.input.MobileTextField
import component.input.TextInputField
import feature.business.viewModel.BusinessViewModel

@Composable
fun CreateBusinessBasicInfo(viewModel: BusinessViewModel) {
    val mobileErrorState = remember {
        mutableStateOf(false)
    }
    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight().padding(8.dp)) {
        if (viewModel.createBusiness.value.Name != null) {
            TextInputField(
                "Name Of the Business/Store",
                value = viewModel.createBusiness.value.Name!!
            ) {
                viewModel.createBusiness.value.Name = it
            }
        } else {
            TextInputField("Name Of the Business") {
                viewModel.createBusiness.value.Name = it
            }
        }
        if (viewModel.createBusiness.value.EmailID != null) {
            TextInputField(
                "Email ID",
                value = viewModel.createBusiness.value.EmailID!!
            ) {
                viewModel.createBusiness.value.EmailID = it
            }
        } else {
            TextInputField("Email ID") {
                viewModel.createBusiness.value.EmailID = it
            }
        }
        Spacer(modifier = Modifier.height(8.dp))
        MobileTextField(
            placeholder = "9000000000",
            trailingIcon = ImageAsset.phone,
            label = "Mobile Number",
            errorState = mobileErrorState,
            keyboardType = KeyboardType.Phone,
            visualTransformation = VisualTransformation.None,
            onChanged = { mob ->
                viewModel.createBusiness.value.mobileNumber = mob.text
            },
            onDialCodeChange = {
                viewModel.createBusiness.value.DialCode = it.countryPhoneCode
            }
        )
        Spacer(modifier = Modifier.height(8.dp))

    }
}